export var convertFormDataToCertificateUpdateRequest = function convertFormDataToCertificateUpdateRequest(formData, _ref) {
  var code = _ref.code,
    externalId = _ref.externalId;
  var certificateDetails = {
    code: code || formData.code,
    title: formData.title || formData.projectTitle,
    authors: formData.authors || formData.projectAuthors,
    allowed: !!formData.allowed
  };
  if (externalId) {
    certificateDetails.externalId = externalId;
  }
  return {
    certificateDetails: certificateDetails
  };
};
export var convertJsonToFormData = function convertJsonToFormData(json) {
  return {
    allowed: json.allowed.value,
    authors: json.authors,
    code: json.code,
    externalId: json.externalId,
    title: json.title,
    uuid: json.uuid
  };
};